import { isNil } from 'lodash'
import { useState } from 'react'

import QuestionForm from '../../../../factories/QuestionForm'
import { useStateWithCallback } from '../../../../functions/useStateWithCallback'
import NavigationButtons from '../../Common/NavigationButton'

const QuestionsComponent = ({
  questions,
  formProducts,
  formData,
  buttonColour,
  buttonTextColour,
  next,
  previous,
  onSubmit = () => {},
  defaultValue,
  memberTypes,
  onBack = () => {},
  defaultCountry,
  hierarchyCountryCode,
}) => {
  let submit = () => {}
  let setSubmitting = () => {}
  const [forward, setForward] = useStateWithCallback(undefined)
  const [touched, setTouched] = useState(false)
  return (
    <div>
      <h3>Just a few more details</h3>
      <hr />
      <QuestionForm
        questions={questions}
        formProducts={formProducts}
        formData={formData}
        bindHandler={({ submitForm, setSubmitting: formSetSubmitting }) => {
          submit = submitForm
          setSubmitting = formSetSubmitting
        }}
        onSubmit={values => {
          onSubmit(values)
          if (isNil(forward) || forward) {
            next()
          } else {
            previous()
          }
        }}
        defaultValue={defaultValue}
        memberTypes={memberTypes}
        defaultCountry={defaultCountry}
        hierarchyCountryCode={hierarchyCountryCode}
        onTouched={() => {
          setTouched(true)
        }}
      />
      <NavigationButtons
        buttonColour={buttonColour}
        buttonTextColour={buttonTextColour}
        onSubmit={async () => {
          await submit() // This will trigger the form validation before setSubmitting happens (to fetch errors)
          await setSubmitting(true)
          await setForward(true, async () => {
            await submit()
          })
        }}
        onBack={() => {
          if (touched) {
            setForward(false, () => {
              submit()
            })
          } else {
            previous()
          }
          onBack()
        }}
      />
    </div>
  )
}

export default QuestionsComponent
